<template>
  <div class="table">
    <div class="table-header">
      <p>Bố cục trang</p>
      <div>
        <!-- <input v-model="filterTerm" placeholder="Tên"/> -->
        <!-- <button @click="addClick" class="add-new" v-if="$checkPermission('create_mediaCAT')">+ Add New</button> -->
      </div>
    </div>

    <div class="table-section">
      <table>
        <thead>
          <tr>
            <th>STT</th>
            <th>Hướng</th>
            <th>Tên</th>
            <th>Thứ tự</th>
            <th>Ngày cập nhật</th>
            <th>Cập nhật bởi</th>
            <th>Hành động</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(ctt, i) in paginatedData" :key="i">
            <td>{{ (currentPage - 1) * pageSize + i + 1 }}</td>
            <td>{{ subForDirection(ctt.direction) }}</td>
            <td>{{ ctt.name }}</td>
            <td>{{ ctt.numOrder }}</td>
            <td>{{ ctt.updatedAtFormatted }}</td>
            <td>{{ ctt.updatedBy }}</td>
            <td>
              <div class="action-holder">
                <button style="background-color: #0298cf;" @click="editClick(ctt)"><i class="fa-solid fa-pen-to-square"></i></button>
                <!-- <button style="background-color: #f80000;" @click="toggleAlert(ctt.id)"
                  v-if="$checkPermission('delete_mediaCAT')"><i class="fa-solid fa-trash"></i></button> -->
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="table-header">
      <p>Màu nền website</p>
    </div>

    <div class="table-section">
      <table>
        <thead>
          <tr>
            <th>STT</th>
            <th>Mã Hex</th>
            <th>Màu</th>
            <th>Ngày cập nhật</th>
            <th>Cập nhật bởi</th>
            <th>Hành động</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(bgc, i) in getBgColor" :key="i">
            <td>1</td>
            <td>{{ bgc.hexValue }}</td>
            <td>
              <div style="display: flex; justify-content: center;">
                <div style="width: 30px; height: 30px; border: 1px solid grey" :style="{ backgroundColor: bgc.hexValue }"></div>
              </div>
            </td>
            <td>{{ bgc.updatedAtFormatted }}</td>
            <td>{{ bgc.updatedBy }}</td>
            <td>
              <div class="action-holder">
                <button style="background-color: #0298cf;" @click="editBgcClick(bgc)"><i class="fa-solid fa-pen-to-square"></i></button>
                <!-- <button style="background-color: #f80000;" @click="toggleAlert(ctt.id)"
                  v-if="$checkPermission('delete_mediaCAT')"><i class="fa-solid fa-trash"></i></button> -->
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- <div class="pagination">
      <div @click="changePage(currentPage - 1)" :disabled="currentPage === 1"><i class="fa-solid fa-angle-left"></i></div>
      <div @click="changePage(1)" v-if="currentPage !== 1">1</div>
      <div v-if="currentPage - 2 >= 1" style="cursor: auto;"><i class="fa-solid fa-ellipsis"></i></div>
      <div style="color: #0298cf; background: rgba(171, 171, 171, 0.2);">{{ currentPage }}</div>
      <div v-if="currentPage + 2 <= totalPages" style="cursor: auto;"><i class="fa-solid fa-ellipsis"></i></div>
      <div @click="changePage(totalPages)" v-if="currentPage !== totalPages">{{ totalPages }}</div>
      <div @click="changePage(currentPage + 1)" :disabled="currentPage === totalPages"><i class="fa-solid fa-angle-right"></i></div>
    </div> -->
  </div>

  <!-- Modal -->
  <base-modal :modalActive="modalActive" :modalTitle="modalTitle" @close="toggleModal">
    <div class="data-display">
      <div class="box"> <p>Tên</p> </div>
      <input type="text" v-model="name" :disabled="true"/>
    </div>

    <div class="data-display">
      <div class="box"> <p>Thứ tự<span style="color: red;">*</span></p> </div>
      <input type="number" v-model="order"/>
    </div>

    <div class="btn-container">
      <!-- <button type="button" :disabled="isClicked" v-if="id === 0" @click="createClick()">Create</button> -->
      <button type="button" :disabled="isClicked" v-if="id !== 0" @click="updateClick()">Cập nhật</button>
    </div>
  </base-modal>

  <!-- Modal -->
  <base-modal :modalActive="modalBgcActive" :modalTitle="'Chỉnh sửa màu nền website'" @close="toggleBgcModal">
    <!-- <div class="data-display">
      <div class="box"> <p>Mã màu<span style="color: red;">*</span></p> </div>
      <input type="text" v-model="hexValue"/>
    </div> -->

    <div class="data-display-color">
      <div class="box"> <p>Màu<span style="color: red;">*</span></p> </div>
      <input type="color" v-model="hexValue"/>
    </div>

    <!-- <div class="data-display">
      <div class="box" style="width: 98px !important;"> <p>Màu</p> </div>
      <div style="height: 35px; width: 37px; border: 1px solid grey" :style="{backgroundColor: hexValue}"></div>
    </div> -->

    <div class="btn-container">
      <!-- <button type="button" :disabled="isClicked" v-if="id === 0" @click="createClick()">Create</button> -->
      <button type="button" :disabled="isClicked" v-if="id !== 0" @click="updateBgcClick()">Cập nhật</button>
    </div>
  </base-modal>

  <alert-modal :modalActive="modalAlert" @close="toggleAlert(selectedId)"
    @delete="deleteClick(selectedId)"></alert-modal>
</template>
<script>
export default {
  data () {
    return {
      pageSize: 9,
      currentPage: 1,
      isValid: true,
      modalActive: false,
      modalAlert: false,
      modalTitle: '',
      filterTerm: '',
      selectedId: 0,
      isLoading: false,
      isClicked: false,
      // data
      id: 0,
      name: '',
      order: 0,
      propertiesToCheck: ['order'],
      // color
      modalBgcActive: false,
      hexValue: ''
    }
  },
  computed: {
    getLayoutAdj () {
      return this.$store.getters['layout/backendLayoutAdj']
    },
    filterItem () {
      if (!this.filterTerm) {
        return this.getLayoutAdj
      }
      this.reloadPageWithFilter()
      const searchTerm = this.filterTerm.toLowerCase()
      return this.getLayoutAdj.filter(data =>
        data.name.toLowerCase().includes(searchTerm)
      )
    },
    paginatedData () {
      const start = (this.currentPage - 1) * this.pageSize
      const end = start + this.pageSize
      return this.filterItem.slice(start, end)
    },
    totalPages () {
      const tp = Math.ceil(this.filterItem.length / this.pageSize)
      if (tp === 0) return 1
      return tp
    },
    getBgColor () {
      return this.$store.getters['color/backendBgColor']
    }
  },
  methods: {
    changePage (page) {
      if (page >= 1 && page <= this.totalPages) {
        this.currentPage = page
      }
    },
    reloadPageWithFilter () {
      this.currentPage = 1
    },
    toggleModal () {
      this.modalActive = !this.modalActive
    },
    toggleBgcModal () {
      this.modalBgcActive = !this.modalBgcActive
    },
    toggleAlert (id) {
      this.selectedId = id
      this.modalAlert = !this.modalAlert
    },
    async getData () {
      this.isLoading = true
      await this.$store.dispatch('layout/getLayoutAdjData')
      await this.$store.dispatch('color/getBgColorData')
      this.isLoading = false
    },
    // addClick () {
    //   this.isClicked = false
    //   this.isValid = true
    //   this.modalTitle = 'Add Media Categories'
    //   this.id = 0
    //   this.name = ''
    //   this.isHidden = false
    //   this.lang = 'vn'
    //   this.createdAt = this.getCurrentDate()
    //   this.author = 'admin'
    //   this.updatedAt = null
    //   this.toggleModal()
    // },
    // async createClick () {
    //   this.isClicked = true
    //   this.validateVariable()
    //   if (!this.isValid) {
    //     this.isClicked = false
    //     this.$showError('Missing necessary data')
    //     return
    //   }
    //   const newMediaCategory = {
    //     name: this.name,
    //     isHidden: this.isHidden,
    //     createdAt: this.createdAt,
    //     updatedAt: this.updatedAt,
    //     author: this.author,
    //     lang: 'all'
    //   }

    //   try {
    //     await this.$store.dispatch('media/postMediaCategories', newMediaCategory)
    //     this.$showSuccess('Add successfully')
    //     this.getLayoutAdjData()
    //     this.toggleModal()
    //   } catch (error) {
    //     this.isClicked = false
    //     if (error.response.data.error_message) {
    //       this.$showError(error.response.data.error_message)
    //     } else {
    //       this.$showError('Đã xảy ra lỗi không mong muốn')
    //     }
    //   }
    // },
    subForDirection (value) {
      if (value === 'horizontal') return 'Chiều ngang'
      else return 'Chiều dọc'
    },
    validateVariable () {
      this.isValid = true
      this.propertiesToCheck.forEach(key => {
        if (!this[key] || this[key] <= 0) {
          this.isValid = false
        }
      })
    },
    editClick (data) {
      this.isClicked = false
      this.toggleModal()
      this.isValid = true
      this.modalTitle = 'Chỉnh sửa bố cục trang'
      this.id = data.id
      this.name = data.name
      this.order = data.numOrder
    },
    async updateClick () {
      this.validateVariable()
      if (!this.isValid) {
        this.$showError('Hãy nhập số thứ tự hợp lệ!')
        return
      }
      const updatedLayout = {
        id: this.id,
        numOrder: this.order
      }

      await this.$store.dispatch('layout/updateLayout', updatedLayout)
      this.getData()
      this.toggleModal()
      // try {
      //   this.$showSuccess('Update successfully')
      //   this.getLayoutAdjData()
      //   this.toggleModal()
      // } catch (error) {
      //   this.isClicked = false
      //   if (error.response.data.error_message) {
      //     this.$showError(error.response.data.error_message)
      //   } else {
      //     this.$showError('Đã xảy ra lỗi không mong muốn')
      //   }
      // },
    },
    editBgcClick (data) {
      this.isClicked = false
      this.toggleBgcModal()
      this.id = data.id
      this.hexValue = data.hexValue
    },
    async updateBgcClick () {
      const updatedBgColor = {
        id: this.id,
        hexValue: this.hexValue
      }

      await this.$store.dispatch('color/updateBackgroundColor', updatedBgColor)
      this.getData()
      this.toggleBgcModal()
    }
    // async deleteClick (id) {
    //   await this.$store.dispatch('media/deleteMediaCategories', id)
    //   const start = (this.currentPage - 1) * this.pageSize
    //   const end = start + this.pageSize
    //   if (this.filterItem.slice(start, end).length === 1 && this.currentPage > 1) {
    //     this.currentPage--
    //   }
    //   this.toggleAlert()
    //   this.getLayoutAdjData()
    // }
  },
  created () {
    this.getData()
  }
}
</script>
<style scoped>
  .table {
    width: 100%;
  }

  /* th, td, button, p, input {
    font-family: "Poppins", sans-serif;
    font-weight: 400;
    font-style: normal;
  } */

  .table-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 20px;
    background-color: rgb(240, 240, 240);
    flex-wrap: wrap;
  }

  .table-header p {
    color: #000;
  }

  button {
    outline: none;
    border: none;
    border-radius: 6px;
    cursor: pointer;
    padding: 10px;
    color: #fff;
  }

  .add-new {
    padding: 10px 20px;
    color: #fff;
    background-color: #0298cf;
  }

  .table-header input {
    padding: 10px 20px;
    margin: 0 10px;
    outline: none;
    border: 1px solid #0298cf;
    border-radius: 6px;
    color: #0298cf;
  }

  ::placeholder {
    color: #0298cf;
  }

  /* table-header end */

  .table-section {
    margin-bottom: 50px;
  }

  table {
    width: 100%;
    table-layout: auto;
    min-width: 1000px;
    border-collapse: collapse;
  }

  thead th {
    position: sticky;
    top: 0;
    background-color: #0298cf;
    color: #fff;
    font-size: 15px;
    height: 50px;
  }

  th,td {
    border-bottom: 1px solid #dddddd;
    padding: 10px 20px;
    text-align: center;
    border-right: 1px solid #dddddd;
    border-left: 1px solid #dddddd;
  }

  td {
    text-align: center;
  }

  tr:hover td {
    background-color: #cfe2ff;
  }

  .action-holder {
    display: flex;
    justify-content: space-around;
  }

  ::-webkit-scrollbar{
    height: 5px;
    width: 5px;
  }

  ::-webkit-scrollbar-track {
    box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3)
  }

  ::-webkit-scrollbar-thumb {
    box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3)
  }

  tr:nth-child(even) {background-color: #ececec }

  th:nth-child(1), td:nth-child(1) {
    text-align: center;
    width: 60px;
  }

  th:nth-child(7), td:nth-child(7) {
    text-align: center;
    width: 120px;
  }
  /* table end */

  .pagination {
    display: flex;
    justify-content: flex-end;
    width: 100%;
    padding: 20px 20px;
  }

  .pagination div{
    padding: 10px;
    border: 1px solid #d5d0d0;
    height: 40px;
    width: 40px;
    border-radius: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #0298cf;
    color: #fff;
    box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.75);
    margin: 0 5px;
    cursor: pointer;
  }

  /* modal */

  .data-display {
    display: flex;
    align-items: center;
    margin-bottom: 30px;
    /* border: 2px solid #000; */
  }

  .data-display-color {
    display: flex;
    align-items: center;
    margin-bottom: 30px;
    /* border: 2px solid #000; */
  }

  .data-display-color .box {
    width: 98px;
  }

  .data-display .box {
    width: 120px;
  }

  .data-display .cb-box {
    width: 100px;
  }

  .data-display input {
    height: 40px;
    width: 100%;
    border-radius: 6px;
    font-size: 17px;
    border: 1px solid #d9d9d9;
    padding: 0px 10px;
  }

  .data-display select {
    height: 40px;
    width: 100%;
    border-radius: 6px;
    font-size: 17px;
    border: 1px solid #d9d9d9;
    padding: 0px 7px;
  }

  .data-display #cb {
    height: 12px;
    width: auto;
    border-radius: 6px;
    font-size: 17px;
    border: 1px solid #d9d9d9;
    padding: 0px 7px;
    margin-right: 10px;
  }

  .data-display label {
    margin-right: 80px;
  }

  .data-display #special-label {
    margin-right: 66px;
  }

  .btn-container {
    display: flex;
    justify-content: flex-end;
    align-items: center;
  }

  .btn-container button {
    padding: 12px 30px;
    color: #fff;
    background-color: #0298cf;
  }

  .errors {
    font-weight: bold;
    color: red;
  }
</style>
